import { render, staticRenderFns } from "./MedicalEquipment.vue?vue&type=template&id=12697161&scoped=true"
import script from "./MedicalEquipment.vue?vue&type=script&lang=js"
export * from "./MedicalEquipment.vue?vue&type=script&lang=js"
import style0 from "./MedicalEquipment.vue?vue&type=style&index=0&id=12697161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12697161",
  null
  
)

export default component.exports